import { render, staticRenderFns } from "./catequest_note_detail.vue?vue&type=template&id=7af57cb3"
import script from "./catequest_note_detail.vue?vue&type=script&lang=js"
export * from "./catequest_note_detail.vue?vue&type=script&lang=js"
import style0 from "./catequest_note_detail.vue?vue&type=style&index=0&id=7af57cb3&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports